import * as types from "./types";
import _ from "lodash";
import { RECRUITMENT_STAGES, stageName } from "@/constants/recruitment_stages";

export default {
  [types.MUTATE_LEAD_TAG_SIDEBAR]: (state, payload) => {
    state.leadTagSidebar = { ...state.leadTagSidebar, ...payload };
  },
  [types.MUTATE_ROADSHOW_SCORE_REVIEW_SIDEBAR]: (state, payload) => {
    state.roadshowScoreReviewSidebar = {
      ...state.roadshowScoreReviewSidebar,
      ...payload,
    };
  },
  [types.MUTATE_RECRUITMENT_STAGES]: (state, payload) => {
    state.recruitmentStages = payload;
  },
  [types.MUTATE_JOB_SAMPLE_PLATFORM_TYPES]: (state, payload) => {
    state.jobSamplePlatformTypes = payload;
  },
  [types.MUTATE_IMPORT_LEADS_SIDEBAR]: (state, payload) => {
    state.importLeadsSidebar = { ...state.importLeadsSidebar, ...payload };
  },
  [types.MUTATE_DISQUALIFY_LEAD_SIDEBAR]: (state, payload) => {
    state.disqualifyLeadSidebar = {
      ...state.disqualifyLeadSidebar,
      ...payload,
    };
  },
  [types.MUTATE_SETTINGS_TABLE_KANBAN_SIDEBAR]: (state, payload) => {
    state.settingsTableKanbanSidebar = {
      ...state.settingsTableKanbanSidebar,
      ...payload,
    };
  },
  [types.MUTATE_RECRUTMENT_KANBAN]: (state, payload) => {
    state.recruitmentList = payload;
  },
  [types.MUTATE_SEARCH_RECRUITMENT_TABLE]: (state, { stage, data }) => {
    const stageId = parseInt(stage);

    const stageData = {
      stage_id: stageId,
      stage_name: stageName(stageId),
      data: data.data || [],
      total: data.total || 0,
      per_page: data.per_page || 10,
      current_page: data.current_page || 1,
    };
    
    const stageIndex = state.searchResult.findIndex(
      (s) => s.stage_id === stageId
    );

    if (stageIndex !== -1) {
      state.searchResult = [
        ...state.searchResult.slice(0, stageIndex),
        stageData,
        ...state.searchResult.slice(stageIndex + 1),
      ];
    } else {
      state.searchResult = [...state.searchResult, stageData];
    }
  },

  [types.MUTATE_SEARCH_RECRUITMENT_TABLE_GROUPED]: (state, payload) => {
    if (!Array.isArray(payload)) {
      state.searchResult = [];
      return;
    }

    if (payload.length === 1 && state.searchResult.length) {
      const stage = payload[0];
      const stageIndex = state.searchResult.findIndex(
        (item) => item.stage_id === stage.stage_id
      );
      if (stageIndex !== -1) {
        state.searchResult = [
          ...state.searchResult.slice(0, stageIndex),
          stage,
          ...state.searchResult.slice(stageIndex + 1),
        ];
        return;
      }
    }

    state.searchResult = payload;
  },

  [types.MUTATE_CLEAR_RECRUITMENT_TABLE]: (state) => {
    state.searchResult = [];
  },

  [types.MUTATE_SETTINGS_TABLE_KANBAN]: (state, payload) => {
    if (typeof payload === "string" || payload instanceof String) {
      state.settingsTableKanban = JSON.parse(payload);
    } else {
      state.settingsTableKanban = payload;
    }
  },
  [types.HIDE_COLUMNS]: (state) => {
    if (!state.settingsTableKanban) return;
    const activeStages = _.map(
      Object.keys(state.settingsTableKanban),
      (column) => {
        if (state.settingsTableKanban[column]) {
          const stage = _.find(RECRUITMENT_STAGES, { setting_key: column });
          return stage.id;
        }
      }
    );
    state.recruitmentList = state.recruitmentList.map((stage) => {
      if (activeStages.includes(stage.stage_id)) {
        stage.hide = false;
      } else {
        stage.hide = true;
      }
      return stage;
    });
  },
  [types.SELECT_MULTIPLE_LEADS]: (state, payload) => {
    if (payload === "all") {
      state.leadsSelected = state.recruitmentList
        .map((stage) => stage.recruitments.map((lead) => lead.customer_id))
        .flat();
    } else if (payload === "none") {
      state.leadsSelected = [];
    } else {
      const stage = _.find(state.recruitmentList, { stage_id: payload });
      if (stage) {
        state.leadsSelected = stage.recruitments.map(
          (lead) => lead.customer_id
        );
      }
    }
  },
  [types.TOGGLE_LEAD_SELECTION]: (state, payload) => {
    if (state.leadsSelected.includes(payload)) {
      state.leadsSelected = state.leadsSelected.filter(
        (lead) => lead !== payload
      );
    } else {
      state.leadsSelected.push(payload);
    }
  },
  [types.MUTATE_MODAL_RECRUITMENT_STAGE]: (state, payload) => {
    state.modalRecruitmentStage.visible = payload.visible;
    if (payload.customer_id) {
      state.leadsSelected = [payload.customer_id];
    }
  },
  [types.MUTATE_JOB_SAMPLE_SETTINGS_SIDEBAR]: (state, payload) => {
    state.jobSampleSettingsSidebar = {
      ...state.jobSampleSettingsSidebar,
      ...payload,
    };
  },
  [types.MOVE_RECRUITMENT]: (state, payload) => {
    const oldStageId = payload.fromStage || payload.recruitment.recruitment_stage_id;
    const oldStage = _.find(state.recruitmentList, { stage_id: oldStageId });
    const newStage = _.find(state.recruitmentList, { stage_id: payload.stage });
    if (oldStage && newStage) {
      const index = _.findIndex(oldStage.recruitments, {
        id: payload.recruitment.id,
      });
      if (index === -1) return;

      const [movedRecruitment] = oldStage.recruitments.splice(index, 1);
      if (oldStage.stage_id !== newStage.stage_id) {
        oldStage.total -= 1;
        newStage.total += 1;
      }

      const updatedRecruitment = {
        ...movedRecruitment,
        ...(payload.updates || {}),
        recruitment_stage_id: payload.stage,
      };
      const insertIndex = Number.isInteger(payload.insertIndex)
        ? Math.min(Math.max(payload.insertIndex, 0), newStage.recruitments.length)
        : 0;
      newStage.recruitments.splice(insertIndex, 0, updatedRecruitment);
    }
  },
  [types.ROLLBACK_RECRUITMENT_MOVE]: (state, payload) => {
    const currentStage = _.find(state.recruitmentList, {
      stage_id: payload.toStage,
    });
    const originalStage = _.find(state.recruitmentList, {
      stage_id: payload.fromStage,
    });

    if (!currentStage || !originalStage) return;

    const currentIndex = _.findIndex(currentStage.recruitments, {
      id: payload.recruitmentId,
    });
    if (currentIndex === -1) return;

    currentStage.recruitments.splice(currentIndex, 1);
    if (currentStage.stage_id !== originalStage.stage_id) {
      currentStage.total -= 1;
      originalStage.total += 1;
    }

    const restoredRecruitment = {
      ...(payload.recruitment || {}),
      recruitment_stage_id: payload.fromStage,
    };
    const insertIndex = Number.isInteger(payload.fromIndex)
      ? Math.min(Math.max(payload.fromIndex, 0), originalStage.recruitments.length)
      : 0;
    originalStage.recruitments.splice(insertIndex, 0, restoredRecruitment);
  },
  [types.START_RECRUITMENT_MOVE]: (state, recruitmentId) => {
    if (!state.recruitmentMovingIds.includes(recruitmentId)) {
      state.recruitmentMovingIds.push(recruitmentId);
    }
  },
  [types.FINISH_RECRUITMENT_MOVE]: (state, recruitmentId) => {
    state.recruitmentMovingIds = state.recruitmentMovingIds.filter(
      (id) => id !== recruitmentId
    );
  },
  [types.MUTATE_BALANCE_LEADDATA]: (state, payload) => {
    state.balanceLeadData = payload;
  },
};
